module.exports = __webpack_public_path__ + "static/media/UCT.1fa839d4.png";